import type { MutationHookOptions } from '@apollo/client'
import { gql, useMutation } from '@apollo/client'

import type {
  IdCheckSelectionEnum,
  R2RSelectionEnum,
} from '@/components/VerifyId/Sidebar/IDVTVerify'
import agentClient from '@/lib/apollo/client/agent'
import type { WrappedMutation } from '@/lib/apollo/types'

const editIdentityFieldsMutation = gql`
  mutation (
    $customerId: String!
    $applicationId: String!
    $subjectId: String!
    $personId: String!
    $request: EditIdentityFieldsRequest!
  ) {
    editIdentityFields(
      customerId: $customerId
      applicationId: $applicationId
      subjectId: $subjectId
      personId: $personId
      request: $request
    ) {
      status
      message
    }
  }
`

export type IdPayload = {
  evidenceFileNames: string[]
  type: string
}

export type MutationVars = {
  customerId: string
  applicationId: string
  subjectId: string
  personId: string
  request: {
    firstName: string
    middleName: string
    lastName: string
    nationality: string
    dateOfBirth: string
    r2RShareCode: string
    companyNamedOfficer: boolean | null
    letterOfAuthorityProvided: boolean | null
    facialMatch: boolean
    id?: IdPayload
    idCheckSelection?: IdCheckSelectionEnum
    r2rCheckSelection?: R2RSelectionEnum
    sanctionsVerified?: boolean
  }
}

export type EditIdentityFieldsData = {
  editIdentityFields: {
    status: 200 | 400
    message: string
  }
}

export const useEditIdentityFieldsMutation: WrappedMutation<
  EditIdentityFieldsData,
  MutationVars
> = (options?: MutationHookOptions<EditIdentityFieldsData, MutationVars>) =>
  useMutation<EditIdentityFieldsData, MutationVars>(editIdentityFieldsMutation, {
    client: agentClient,
    ...options,
  })
